import React, { useRef, useEffect, useState } from 'react';
import ToolAccordion from '../ToolAccordion/ToolAccordion';

/**
 * AutoScrollAccordion - A wrapper component that automatically scrolls opened accordions into view
 * when they would otherwise extend beyond the viewport.
 */
const AutoScrollAccordion = ({
  title,
  children,
  AccordionSummaryStyle = {},
  AccordionContainerStyle = {},
  RightIconComponent,
  isTootTipShow = false,
  toolTipDescription = null,
  accordionIcon,
  hideDivider,
  ...rest
}) => {
  const contentRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  
  const handleExpand = (isExpanded) => {
    setExpanded(isExpanded);
  };
  
  useEffect(() => {
    if (expanded && contentRef.current) {
      // Calculate if the element is partially out of viewport
      const rect = contentRef.current.getBoundingClientRect();
      const isPartiallyOutOfView = rect.bottom > window.innerHeight;
      
      if (isPartiallyOutOfView) {
        // Small delay to allow the accordion animation to start
        setTimeout(() => {
          // Scroll to make the content visible with a small offset
          contentRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }, 150);
      }
    }
  }, [expanded]);
  
  return (
    <div>
      <ToolAccordion
        title={title}
        AccordionSummaryStyle={AccordionSummaryStyle}
        AccordionContainerStyle={AccordionContainerStyle}
        RightIconComponent={RightIconComponent}
        isTootTipShow={isTootTipShow}
        toolTipDescription={toolTipDescription}
        accordionIcon={accordionIcon}
        hideDivider={hideDivider}
        onChange={handleExpand}
        {...rest}
      >
        <div ref={contentRef}>
          {children}
        </div>
      </ToolAccordion>
    </div>
  );
};

export default AutoScrollAccordion; 